import { Component, EventEmitter, Input, Output } from "@angular/core";
import { RecordLockService } from '../../services/recordlock.service';
import { UtilService } from '../../services/util.service';
//import {
//    RecordLockType,
//    RecordType,
//    SearchRecordLock
//} from "../../models/models";

@Component({
    selector: 'record-lock-modal',
    templateUrl: './record-lock-modal.component.html',
    standalone: false
})
export class RecordLockModal {
    //@Input() recordID: number = 0;
    //@Input() recordTypeName: string = "";
    //@Input() lockSource: string = "";
    @Output() cancelOverride = new EventEmitter<any>();
    //@Output() overrideRecordLock = new EventEmitter<any>();
    //@Output() continueRecordLockAction = new EventEmitter<any>();
    @Output() confirmTimeout = new EventEmitter<any>();

    public recordID: number = 0;
    public recordTypeName: string = "";
    public lockSource: string = "";

    //public isLocked: boolean = false;
    //public recordLockType: RecordLockType = {} as RecordLockType;
    //public recordType: RecordType = {} as RecordType;
    //public searchRecordLock: SearchRecordLock = {} as SearchRecordLock;

    constructor(public recordLockService: RecordLockService, public utilService: UtilService) {
    }

    public override() {
        //this.recordLockService.overrideRecordLock(this.recordID, this.lockSource);
        this.recordLockService.overrideRecordLock();
    }

    public xoverride() {
        //this.recordLockService.continueRecordLockObserver.subscribe(result => {
        //    console.log("recordLockService:override:continue", this.recordLockService.isContinueRecordLock);
        //    if (this.recordLockService.isContinueRecordLock) {
        //        //this.continue();
        //    }
        //});

        //console.log("overrideRecordLock", id, this.recordLockService.recordLock);
        //if (this.recordLockService.recordLock && this.recordLockService.recordLock.recordID == id) {
        //    this.recordLockService.recordLock.recordLockTypeID = this.recordLockService.recordLockTypeList.find(r => r.recordLockTypeName == "Overridable")!.recordLockTypeID;
        //    this.recordLockService.recordLock.checkedOutByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
        //    this.recordLockService.recordLock.dateCheckedOut = this.utilService.getDateAsUTC(new Date());
        //    this.recordLockService.recordLock.releasedByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
        //    this.recordLockService.recordLock.dateReleased = this.utilService.getDateAsUTC(new Date());

        //    this.recordLockService.saveRecordLock(this.recordLockService.recordLock).subscribe(result => {
        //        console.log("overrideRecordLock", id, result, this.recordLockService.recordLock);
        //        if (result.resultCollection.length > 0) {
        //            this.recordLockService.recordLock = result.resultCollection[0];
        //            this.isLocked = false;
        //            this.continueRecordLockAction.emit();
        //        }
        //    });
        //}
    }

    public cancel() {
        //this.cancelOverride.emit();
        // Unlock after sending back the cancel handler
        this.recordLockService.cancelOverrideObserver.next(true);
        //this.recordLockService.isLocked = false;
    }

    //public continue() {
    //    console.log("recordLockModal:continue");
    //    this.continueRecordLockAction.emit();
    //}

    public continueTimeout() {
        //this.confirmTimeout.emit();
        //console.log("record-lock-modal:continueTimeout", this.recordLockService.isTimeout, this.recordLockService.searchRecordLock);
        //console.log("record-lock-modal:continueTimeout", this.recordLockService.isTimeout, this.recordLockService.searchRecordLock);
        //this.recordLockService.isTimeout = false;
        this.recordLockService.timeoutConfirmObserver.next(true);
    }

    public continueRefresh() {
        this.recordLockService.timeoutConfirmObserver.next(true);
    }
}
